export default "__VITE_ASSET__ceE8$L_m__"